import { IMetadataState } from '.';
import { RootState } from '../rootReducer';

export const getMetadata = (state: RootState): IMetadataState => {
  return state.metadata;
};
